// extracted by mini-css-extract-plugin
module.exports = {"main":"login_main__a7aX9","image":"login_image___LTIy","submit":"login_submit__33GeC","spinner":"login_spinner__Ss8Kk","spinner-animation":"login_spinner-animation__YpGXt"};